import { render, staticRenderFns } from "./UpdateUserGeneralInfoModal.vue?vue&type=template&id=77b40f70&"
import script from "./UpdateUserGeneralInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserGeneralInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports